import classNames from 'classnames';
import { FC, MouseEventHandler } from 'react';

import { IcAddPullRefresh32Icon, IcClose32Icon } from '@gem/icons';
import { FAB } from '@gem/ui-kit';

import styles from './AllDownloadsItemActions.styles.m.css';

interface IAllDownloadsItemActionsProps {
  className?: string;
  onRetry: MouseEventHandler<HTMLButtonElement>;
  onRemove: MouseEventHandler<HTMLButtonElement>;
}

export const AllDownloadsItemActions: FC<IAllDownloadsItemActionsProps> = (props) => {
  const { className, onRetry, onRemove } = props;

  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.smoothOpacity} />
      <div className={styles.icons}>
        <FAB
          className={classNames(styles.retryIcon)}
          Icon={IcAddPullRefresh32Icon}
          size="10"
          iconSize="60"
          theme="3"
          onClick={onRetry}
        />
        <FAB
          className={classNames(styles.removeIcon)}
          Icon={IcClose32Icon}
          size="10"
          iconSize="60"
          theme="3"
          onClick={onRemove}
        />
      </div>
    </div>
  );
};
